import { createReducer } from '../lib/createReducer.js';

const initialState = {
  companyIntegrationsProjects: []
};

export default createReducer(initialState, {
  GET_COMPANY_INTEGRATIONS_PROJECTS_SUCCESS: (state, payload) => ({
    ...state,
    companyIntegrationsProjects: payload?.data || []
  })
});
